import { render } from "./ClinicsPanel.vue?vue&type=template&id=77e05fb2&scoped=true"
import script from "./ClinicsPanel.vue?vue&type=script&lang=js"
export * from "./ClinicsPanel.vue?vue&type=script&lang=js"

import "./ClinicsPanel.vue?vue&type=style&index=0&id=77e05fb2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e05fb2"]])

export default __exports__